import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './idb-status-icon.css.lit';
import { OutlineElement } from 'src/components/base/outline-element/outline-element';

/**
 * The IDB Status Icon component.
 * @element idb-status-icon
 * @extends OutlineElement
 */
@customElement('idb-status-icon')
export class IdbStatusIcon extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  @property({ type: String, attribute: 'value' })
  value: string;

  @property({ type: String, attribute: 'status' })
  status: string;

  @property({ type: String, attribute: 'icon' })
  icon: string;

  render(): TemplateResult {
    return html`
      <div class="status ${this.status} ${
      this.value ? 'show-value' : 'hidden-value'
    }">
        <span>
          ${this.value}
        </span>
          <idb-icon icon="${
            this.icon
          }" size="15px" color="currentColor" stroke-width="3"></idb-icon> 
      </div>
    `;
  }
}
